import React from 'react';
import { Link } from 'react-router-dom';
import './Subsidiaries.css';

const SubsidiariesSection: React.FC = () => {
  return (
    <section id="subsidiaries" className="subsidiaries section">
      <div className="container">
        <div className="section-header">
          <h2>Our Subsidiaries</h2>
          <p>Specialized companies delivering excellence in their respective domains</p>
        </div>
        <div className="subsidiaries-grid">
          <div className="subsidiary-card">
            <div className="card-icon">
              <i className="fas fa-network-wired"></i>
            </div>
            <h3>New Wave ICT Hub Limited</h3>
            <p>Delivering cutting-edge active and passive telecommunications devices and infrastructure solutions to locations nationwide.</p>
            <ul>
              <li>Telecommunications Infrastructure</li>
              <li>Network Solutions</li>
              <li>ICT Consulting</li>
              <li>Technology Integration</li>
            </ul>
            <Link to="/ict-hub" className="card-link">
              Learn More →
            </Link>
          </div>

          <div className="subsidiary-card">
            <div className="card-icon">
              <i className="fas fa-tools"></i>
            </div>
            <h3>New Wave Projects Limited</h3>
            <p>Partnering with third-party specialists to engineer and install comprehensive networking and communication solutions.</p>
            <ul>
              <li>Project Management</li>
              <li>Engineering Solutions</li>
              <li>Installation Services</li>
              <li>Technical Consulting</li>
            </ul>
            <Link to="/projects" className="card-link">
              Learn More →
            </Link>
          </div>

          <div className="subsidiary-card">
            <div className="card-icon">
              <i className="fas fa-building"></i>
            </div>
            <h3>New Wave Estate & Properties Development Limited</h3>
            <p>Creating premium real estate solutions and property development projects that transform communities.</p>
            <ul>
              <li>Property Development</li>
              <li>Real Estate Investment</li>
              <li>Urban Planning</li>
              <li>Property Management</li>
            </ul>
            <Link to="/estate" className="card-link">
              Learn More →
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SubsidiariesSection;
